import { avatarMissing, headerMissing } from "@/schemas/account";

import type { Account } from "@/schemas";

const getDomainFromURL = (account: Pick<Account, "url">): string => {
  try {
    const url = account.url;
    return new URL(url).host;
  } catch {
    return "";
  }
};

export const getDomain = (account: Pick<Account, "acct" | "url">): string => {
  const domain = account.acct.split("@")[1];
  return domain ? domain : getDomainFromURL(account);
};

/** Default header filenames from various backends */
const DEFAULT_HEADERS = [headerMissing];

/** Check if the avatar is a default avatar */
export const isDefaultHeader = (url: string) => {
  return DEFAULT_HEADERS.some((header) => url.endsWith(header));
};

/** Default avatar filenames from various backends */
const DEFAULT_AVATARS = [avatarMissing];

/** Check if the avatar is a default avatar */
export const isDefaultAvatar = (url: string) => {
  return DEFAULT_AVATARS.some((avatar) => url.endsWith(avatar));
};
